import { useTranslation } from 'next-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import { RegistrationField } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { RegistrationFormFieldProps } from '../RegistrationFormField';

interface RegistrationPhoneNumberInterface
  extends Pick<RegistrationFormFieldProps, 'field' | 'defaultValue' | 'fieldsTextColor' | 'fieldsBorderColor' | 'showFieldLabel'> {
  isRequired: (field: RegistrationField) => boolean;
  onChange?: (key: string, value: string) => void;
  onBlur?: (key: string, value: string) => void;
  disabled?: boolean;
}

const RegistrationPhoneNumber = ({
  field: registrationField,
  defaultValue,
  fieldsBorderColor,
  fieldsTextColor,
  isRequired,
  showFieldLabel,
  onChange,
  onBlur,
  disabled,
}: RegistrationPhoneNumberInterface) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const event = useSelector((state) => state.common.event);

  return (
    <div>
      {showFieldLabel !== false && <span className="text-current">{registrationField.label}</span>}
      <Controller
        control={control}
        name={registrationField._id}
        key={registrationField._id}
        rules={{
          pattern: { value: new RegExp(/^\+(?:[0-9] ?){6,14}[0-9]$/), message: t('event:wrong-phone-format') },
          required: {
            value: isRequired(registrationField),
            message: t('event:required-field-error'),
          },
        }}
        defaultValue={defaultValue || undefined}
        render={({ field }) => (
          <>
            <label
              id={`phonenumber-${registrationField._id}`}
              className="flex justify-between items-center p-4 my-2 rounded border-2 cursor-pointer"
              style={{ background: 'inherit', border: `0.1px solid ${fieldsBorderColor || event?.template.mainColor}`, justifyContent: 'center' }}>
              <PhoneInput
                disabled={disabled}
                ref={field.ref}
                placeholder={registrationField.label}
                value={field.value}
                onChange={(number) => {
                  if (onChange) onChange(registrationField._id, number?.toString()!);
                  else field.onChange(number);
                }}
                onBlur={() => {
                  if (onBlur) onBlur(registrationField._id, field.value?.toString()!);
                  else field.onBlur();
                }}
                style={{ width: '100%', color: fieldsTextColor || event?.template.mainColor }}
                className="[&>input]:bg-inherit [&>input]:outline-none"
                defaultCountry="DE"
                international={true}
              />
            </label>
          </>
        )}
      />
      <p className="text-xs text-[#FF1744] mx-[14px] mt-[3px] font-sans">{errors[registrationField._id]?.message?.toString()}</p>
    </div>
  );
};
export default RegistrationPhoneNumber;
